import React, { useRef, useState } from 'react';
import DisabledMessage from "../../../../../../CommonComponents/MouseTrackingMessage/MouseTrackingMessage";
import {
    BlurContainer,
    BlurOverlay,
} from '../../../../../../CommonComponents/commonStyles';
import { recordError } from "../../../../../../utils/commonUtil";

const Blur = (props) => {
    const { isEnabled } = props;
    const ref = useRef(null);
    const [position, setPosition] = useState({
        left: null,
        top: null,
    });
    const [display, setDisplay] = useState(false);

    const onClick = (e) => {
        try {
            setDisplay(true);
            setPosition({
                left: e.clientX - ref.current.getBoundingClientRect().left,
                top: e.clientY - ref.current.getBoundingClientRect().top,
            })
        } catch (error) {
          recordError(error);
        }
    }

    const onMouseLeave = () => {
        setDisplay(false);
        setPosition({
            left: null,
            top: null
        })
    }

    return (
        <BlurContainer ref={ref} onClick={onClick} onMouseLeave={onMouseLeave}>
            <BlurOverlay isEnabled={isEnabled} />
            {display && <DisabledMessage message="Please select the exchange type to proceed." isEnabled={isEnabled}
                pos={position}
            />}
            {props.children}
        </BlurContainer>
    );
}

export default Blur;